// src/components/BirthdayBanner.js
// Shows a special banner on the member's birthday
// Platinum members get a special message
import './BirthdayBanner.css'

export default function BirthdayBanner({ profile, tier }) {
  if (!profile?.birthday) return null

  const today = new Date()
  const bday = new Date(profile.birthday)
  const isBirthday =
    today.getMonth() === bday.getMonth() &&
    today.getDate() === bday.getDate()

  if (!isBirthday) return null

  return (
    <div className="bday-banner">
      <div className="bday-banner__inner">
        <div className="bday-banner__icon">🌹</div>
        <div className="bday-banner__content">
          <p className="bday-banner__title">
            Happy Birthday, {profile.display_name}
          </p>
          <p className="bday-banner__sub">
            {tier === 'platinum'
              ? 'Sky Bri has sent you a special birthday message — check your chat 🎁'
              : 'Sky Bri is thinking of you on your special day. Enjoy it.'}
          </p>
        </div>
        <div className="bday-banner__confetti">✦ ◈ ✦</div>
      </div>
    </div>
  )
}
